const headers = [
  {
    text: 'id',
    value: 'storageId',
    sortable: true,
    width: '6%',
    align: 'center'
  },
  {
    text: 'sale.sale_status',
    value: 'isEnabled',
    sortable: true,
    width: '8%',
    align: 'center'
  },
  {
    text: 'product.product_storage-name',
    value: 'name',
    sortable: true,
    width: '13%'
  },
  {
    text: 'product.product_recipient-name',
    value: 'storageRecipientName',
    sortable: false,
    width: '13%',
    rowspan: false
  },
  {
    text: 'product.product_recipient-address',
    value: 'storageRecipientAddress',
    sortable: false,
    width: '22%',
    rowspan: false
  },
  {
    text: 'product.product_recipient-tel',
    value: 'storageRecipientPhoneNumber',
    sortable: false,
    width: '14%',
    rowspan: false
  },
  {
    text: 'product.product_recipient-memo',
    value: 'storageRecipientNote',
    sortable: false,
    width: '29%',
    rowspan: false
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '8%'
  }
]
export default { headers }
